import { render, staticRenderFns } from "./ChannelFilter.vue?vue&type=template&id=2ffcdb74&scoped=true&"
import script from "./ChannelFilter.vue?vue&type=script&lang=ts&"
export * from "./ChannelFilter.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelFilter.vue?vue&type=style&index=0&id=2ffcdb74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffcdb74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCard,VContainer,VIcon,VList,VMenu,VRow,VTreeview})
